import React, { useState } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { toast } from 'react-toastify';

const RefundModal = ({ isOpen, onClose, orderId, amount, onRefundInitiated }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await callAPI(apiUrls.LINKLY_REFUND, {}, 'POST', {
        order_id: orderId,
        amount: amount,
        reason: reason,
      });

      if (res?.data?.status === 1) {
        const refundSessionId = res.data.data?.refund_session_id;
        toast.success('Refund initiated — please follow terminal prompts');
        setReason('');
        onClose();
        if (onRefundInitiated) onRefundInitiated(refundSessionId);
      } else {
        toast.error(res?.data?.message || 'Refund failed');
      }
    } catch (err) {
      toast.error('Refund request failed');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} elId="refundModal">
      <div className="modal-header">
        <h5 className="modal-title">EFTPOS Refund</h5>
        <button type="button" className="btn-close" onClick={handleClose} />
      </div>
      <div className="modal-body">
        <div className="mb-3">
          <label className="form-label">Refund Amount</label>
          <input
            type="text"
            className="form-control"
            value={`$${amount}`}
            readOnly
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Reason (optional)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Reason for refund"
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={handleClose} disabled={submitting}>
          Cancel
        </button>
        <button className="btn btn-danger" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Processing...' : 'Submit Refund'}
        </button>
      </div>
    </CommonModal>
  );
};

export default RefundModal;
